import { SemanticCOLORS, SemanticICONS } from "semantic-ui-react";

import moment from "moment";

import AvailableAffiliateListAPI from "issara-sdk/apis/AvailableAffiliateListAPI_users";

import AffiliateSerializer from "issara-sdk/types/AffiliateSerializer_users";
import EmployeeSerializer from "issara-sdk/types/EmployeeSerializer_users";

import { ADMIN_NAME_LIST, ADMIN_TAB_LIST } from "react-lib/apps/USER/CardSettingDivision";

import * as CourseList from "./sequence/CourseList";
import * as DSPermission from "./sequence/DSPermission";
import * as EmployeeDocument from "./sequence/EmployeeDocument";
import * as EmployeeHistory from "./sequence/EmployeeHistory";
import * as EmployeeInfo from "./sequence/EmployeeInfo";
import * as EmployeeList from "./sequence/EmployeeList";
import * as EmployeePayment from "./sequence/EmployeePayment";
import * as EmployeeSWH from "./sequence/EmployeeSWH";
import * as EmployeeTA from "./sequence/EmployeeTA";
import * as LeavePolicy from "./sequence/LeavePolicy";
import * as Payroll from "./sequence/Payroll";
import * as SelfServicePaySlip from "./sequence/SelfServicePaySlip";
import * as SelfServiceSchedule from "./sequence/SelfServiceSchedule";
import * as SetupWorkSchedule from "./sequence/SetupWorkSchedule";
import * as SummaryTrainingKPI from "./sequence/SummaryTrainingKPI";
import * as TrainingHistory from "./sequence/TrainingHistory";
import * as TrainingKPISetting from "./sequence/TrainingKPISetting";
import * as TrainingManagement from "./sequence/TrainingManagement";
import * as WorkSchedule from "./sequence/WorkSchedule";

import { ActionHandler, PickMainState } from "../common/CommonInterface";

export type State = CourseList.State &
  DSPermission.State &
  EmployeeDocument.State &
  EmployeeHistory.State &
  EmployeeInfo.State &
  EmployeeList.State &
  EmployeePayment.State &
  EmployeeSWH.State &
  EmployeeTA.State &
  LeavePolicy.State &
  Payroll.State &
  SelfServicePaySlip.State &
  SelfServiceSchedule.State &
  SetupWorkSchedule.State &
  SummaryTrainingKPI.State &
  TrainingHistory.State &
  TrainingKPISetting.State &
  TrainingManagement.State &
  WorkSchedule.State & { selectedEmployee: EmployeeSerializer | null };

export type PickedState = PickMainState<
  | "adminMenuDivisions"
  | "buttonLoadCheck"
  | "django"
  | "errorMessage"
  | "searchedItemListWithKey"
  | "selectedDivision"
>;

export type AffiliateSearchParamsType = {
  abortController?: any;

  items: AffiliateSerializer[];
  parent?: number;
  search?: string;
};

export type AvailableAffiliateParamsType = Omit<AffiliateSearchParamsType, "items">;

export type AdminMenuListKey = keyof typeof ADMIN_MENU_LIST;

export type Props = {};

export type Handler<P = unknown, R = void> = ActionHandler<State, Event, Data, P, R>;

export const StateInitial: State = { selectedEmployee: null };

export type Event =
  | CourseList.Event
  | DSPermission.Event
  | EmployeeDocument.Event
  | EmployeeHistory.Event
  | EmployeeInfo.Event
  | EmployeeList.Event
  | EmployeePayment.Event
  | EmployeeSWH.Event
  | EmployeeTA.Event
  | LeavePolicy.Event
  | Payroll.Event
  | SelfServicePaySlip.Event
  | SelfServiceSchedule.Event
  | SetupWorkSchedule.Event
  | SummaryTrainingKPI.Event
  | TrainingHistory.Event
  | TrainingKPISetting.Event
  | TrainingManagement.Event
  | WorkSchedule.Event;

export type Data =
  | CourseList.Data &
      DSPermission.Data &
      EmployeeDocument.Data &
      EmployeeHistory.Data &
      EmployeeInfo.Data &
      EmployeeList.Data &
      EmployeePayment.Data &
      EmployeeSWH.Data &
      EmployeeTA.Data &
      LeavePolicy.Data &
      Payroll.Data &
      SelfServicePaySlip.Data &
      SelfServiceSchedule.Data &
      SetupWorkSchedule.Data &
      SummaryTrainingKPI.Data &
      TrainingHistory.Data &
      TrainingKPISetting.Data &
      TrainingManagement.Data &
      WorkSchedule.Data;

export const DataInitial = {
  ...Payroll.DataInitial,
  ...WorkSchedule.DataInitial,
};

export const LOG_TYPES_OPTIONS = [
  { key: "I", text: "Clock-in", value: "I" },
  { key: "O", text: "Clock-out", value: "O" },
];

export const COURSE_TYPE_OPTIONS = [
  { key: "ONLINE", text: "Online", value: "ONLINE" },
  { key: "OUTSIDE", text: "Outside", value: "OUTSIDE" },
  { key: "ONSITE", text: "Onsite", value: "ONSITE" },
];

export const COURSE_STATUS_OPTIONS = [
  { key: "OPEN", text: "Open", value: "OPEN" },
  { key: "CLOSE", text: "Closed", value: "CLOSE" },
  { key: "IN_PROGRESS", text: "In Progress", value: "IN_PROGRESS" },
  { key: "COMPLETE", text: "Complete", value: "COMPLETE" },
];

export const ATTENDANCE_STATUS_OPTIONS = [
  { key: "APPROVE", text: "Attend", value: "APPROVE" },
  { key: "ABSTAIN", text: "Abstain", value: "ABSTAIN" },
];

export const ORGANIZE_LABEL = "องค์กร";

export const ADMIN_MENU_LIST = {
  ...ADMIN_NAME_LIST,
  [ADMIN_NAME_LIST.Payroll]: [
    ADMIN_TAB_LIST.Salary,
    ADMIN_TAB_LIST["Revenue & Deduct"],
    ADMIN_TAB_LIST["Setting"],
  ],
  [ADMIN_NAME_LIST.ข้อมูลบุคลากร]: [
    ADMIN_TAB_LIST["Employee Information"],
    ADMIN_TAB_LIST["Division/Special permission"],
    ADMIN_TAB_LIST["Employee Document"],
    ADMIN_TAB_LIST["Employee payment detail"],
    ADMIN_TAB_LIST["Employee info history"],
  ],
  [ADMIN_NAME_LIST["Self Service & Time Schedule"]]: [
    ADMIN_TAB_LIST["My shift schedule"],
    ADMIN_TAB_LIST["Time Attendance"],
    ADMIN_TAB_LIST["Leave History"],
    ADMIN_TAB_LIST["Training History"],
    ADMIN_TAB_LIST["PaySlip"],
  ],
  [ADMIN_NAME_LIST["Training System"]]: [
    ADMIN_TAB_LIST["Course List"],
    ADMIN_TAB_LIST["Training KPI Setting"],
    ADMIN_TAB_LIST["Summary Training KPI"],
    ADMIN_TAB_LIST["Training Schedule"],
  ],
  [ADMIN_NAME_LIST["Work & Plan System"]]: [
    ADMIN_TAB_LIST["Issue list"],
    ADMIN_TAB_LIST["Project list"],
  ],
  [ADMIN_NAME_LIST["Work Schedule"]]: [
    ADMIN_TAB_LIST["Set up Work Schedule"],
    ADMIN_TAB_LIST["Set up Work Shift template"],
    ADMIN_TAB_LIST["Employee Attendance"],
    ADMIN_TAB_LIST["Employee Leave Request"],
    ADMIN_TAB_LIST["Employee Training"],
    ADMIN_TAB_LIST["Training Management"],
    ADMIN_TAB_LIST["Summary Work Hour/Month"],
  ],
} as const;

// Handler
export const SearchAvailableAffiliate: Handler<
  AffiliateSearchParamsType,
  Promise<{ items: AffiliateSerializer[]; message: "canceled" | "search" | "update" }>
> = async (controller, params) => {
  const [affiliate, error] = await GetAvailableAffiliateList(controller, params);

  const affiliateItems = affiliate?.items ?? [];

  if (error === "canceled") {
    return { items: [], message: error };
  }

  if ("search" in params) {
    return { items: affiliateItems, message: "search" };
  }

  const updateNodesWithChildren = (items: Record<string, any>[]) =>
    items.map((item): Record<string, any> => {
      // หา item ที่มี id ตรงกับ parentId
      if (item.id === Number(params.parent)) {
        return { ...item, children: affiliateItems };
      }

      // ถ้ามี children ให้ทำ recursive ต่อไป
      else if (Array.isArray(item.children)) {
        return { ...item, children: updateNodesWithChildren(item.children) };
      }

      return item;
    });

  return {
    items: updateNodesWithChildren(params.items),
    message: "update",
  };
};

export const GetAvailableAffiliateList: Handler<
  AvailableAffiliateParamsType,
  Promise<[{ items: AffiliateSerializer[] } | null, unknown]>
> = async (controller, params) => {
  const abortController = new AbortController();

  if (params.abortController) {
    params.abortController.current = abortController;
  }

  return AvailableAffiliateListAPI.list({
    apiToken: controller.apiToken,
    params: { parent: params.parent, search: params.search },
    extra: {
      signal: abortController.signal,
    },
  }) as Promise<[{ items: AffiliateSerializer[] } | null, unknown]>;
};

// Utils
export const getCourseApproveStatus = (
  status: string | undefined
): { color: SemanticCOLORS; icon: SemanticICONS; name: string } | null => {
  if (status === "ABSTAIN") {
    return {
      color: "red",
      icon: "remove circle",
      name: "Abstain",
    };
  } else if (status === "APPROVE") {
    return {
      color: "green",
      icon: "check circle",
      name: "Attend",
    };
  }

  return null;
};

export const getCourseStatusColor = (status: string | undefined) => {
  if (status === "IN_PROGRESS") {
    return "#DF6011";
  } else if (status === "COMPLETE") {
    return "#009B14";
  }

  return "";
};

// คำนวณจำนวนชั่วโมงนาที: (end - start) - (break_end - break_start) return { hours: number, minutes: number };
export const calculateTotalWorkingTime = ({
  endBreakTime,
  endTime,
  isBreakTime,
  startBreakTime,
  startTime,
}: {
  endBreakTime?: string | null;
  endTime?: string;
  isBreakTime?: boolean;
  startBreakTime?: string | null;
  startTime?: string;
}): { hours: number; minutes: number } => {
  if (!startTime || !endTime) {
    return { hours: 0, minutes: 0 };
  }

  const start = moment(startTime, "HH:mm");
  const end = moment(endTime, "HH:mm");
  const endAdjusted = end.isBefore(start) ? end.add(1, "day") : end;

  let duration = moment.duration(endAdjusted.diff(start));

  if (isBreakTime && startBreakTime && endBreakTime) {
    const breakStart = moment(startBreakTime, "HH:mm");
    const breakEnd = moment(endBreakTime, "HH:mm");
    const breakEndAdjusted = breakEnd.isBefore(breakStart) ? breakEnd.add(1, "day") : breakEnd;

    const breakDuration = moment.duration(breakEndAdjusted.diff(breakStart));

    duration = duration.subtract(breakDuration);
  }

  const totalMinutes = duration.asMinutes();

  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: Math.floor(totalMinutes % 60),
  };
};

// Format Time String "HH:mm:ss" --> "HH:mm"
export const formatTimeHideSeconds = (timeStr?: string | null) => {
  if (!timeStr) {
    return "";
  }

  const [hour, minute] = timeStr.split(":");

  return `${hour}:${minute}`;
};

const filterDivisions = (
  divisions: Record<string, any>[],
  searchTerm?: string,
  allowedTypes?: string[]
): Record<string, any>[] =>
  divisions.filter((division) => {
    // กรอง search term
    if (searchTerm?.trim()) {
      const name: string = division.name || "";

      if (!name.toLowerCase().includes(searchTerm.toLowerCase())) {
        return false;
      }
    }

    // กรอง type
    return !(allowedTypes && !allowedTypes.includes(division.type_label));
  });

export const checkLeaveTimeOutsideShift = (
  leaveStartTime?: string,
  leaveEndTime?: string,
  shift?: { end_time?: string | null; start_time?: string | null }
) => {
  // คืนค่าเริ่มต้นหากไม่มีข้อมูลกะการทำงาน
  if (!shift) {
    return { isEndOutside: false, isStartOutside: false };
  }

  const shiftStart = moment(shift.start_time, "HH:mm");
  const shiftEnd = moment(shift.end_time, "HH:mm");

  // จัดการกะข้ามคืน (เวลาสิ้นสุดเป็นวันถัดไป)
  if (shiftEnd.isBefore(shiftStart)) {
    shiftEnd.add(1, "day");
  }

  // ตรวจสอบว่าเวลาอยู่นอกช่วงกะการทำงานหรือไม่
  const isTimeOutsideShift = (timeString?: string) => {
    if (!timeString) {
      return false;
    }

    // ลองใช้เวลาร่วมกับวันที่ของ shiftEnd ก่อน (สำหรับกะข้ามคืน)
    const timeWithEndDate = moment(`${shiftEnd.format("YYYY-MM-DD")} ${timeString}`);
    const timeToCheck = timeWithEndDate.isBetween(shiftStart, shiftEnd, null, "[]")
      ? timeWithEndDate
      : moment(`${shiftStart.format("YYYY-MM-DD")} ${timeString}`);

    // คืนค่า true หากเวลาอยู่นอกช่วงกะการทำงาน
    return !timeToCheck.isBetween(shiftStart, shiftEnd, null, "[]");
  };

  return {
    isEndOutside: isTimeOutsideShift(leaveEndTime), // เวลาสิ้นสุดลาอยู่นอกกะ
    isStartOutside: isTimeOutsideShift(leaveStartTime), // เวลาเริ่มลาอยู่นอกกะ
    shiftEnd,
    shiftStart,
  };
};

// ตรวจสอบว่าเวลาอยู่ในช่วงเวลาทำงานหรือไม่
export const isTimeWithinShift = (
  shiftStart: moment.Moment,
  shiftEnd: moment.Moment,
  timeIn?: number | string | null,
  timeOut?: number | string | null
) => {
  if (!timeIn || !timeOut) {
    return true;
  }

  const date = shiftStart.format("YYYY-MM-DD");

  const timeStart = moment(`${date} ${timeIn}`);
  const timeEnd = moment(`${date} ${timeOut}`);

  if (shiftEnd.isAfter(shiftStart, "days")) {
    if (timeStart.isBefore(shiftStart) && timeStart.isBefore(shiftEnd)) {
      timeStart.add(1, "day");
    }

    if (timeEnd.isBefore(shiftStart) && timeEnd.isBefore(shiftEnd)) {
      timeEnd.add(1, "day");
    }
  }

  // จัดการกรณีข้ามคืน
  if (timeEnd.isBefore(timeStart)) {
    timeEnd.add(1, "day");
  }

  // ตรวจสอบว่าเวลาทั้งเริ่มและสิ้นสุดอยู่ในช่วงเวลาทำงานหรือไม่
  const isStartValid = timeStart.isBetween(shiftStart, shiftEnd, null, "[]");
  const isEndValid = timeEnd.isBetween(shiftStart, shiftEnd, null, "[]");

  return isStartValid && isEndValid;
};

export const abbreviateThaiName = (name: string) => {
  const parts = name.split(" ");
  const lastName = parts.slice(2).join(" ");

  // ตรวจสอบว่าต้องเอา 2 ตัวแรกหรือแค่ 1 ตัว
  const frontVowels = ["เ", "แ", "โ", "ใ", "ไ"];
  const aboveBelowVowels = ["ะ", "ั", "า", "ำ", "ิ", "ี", "ึ", "ื", "ุ", "ู"];
  const shouldUseTwoChars =
    frontVowels.includes(lastName[0]) || aboveBelowVowels.includes(lastName[1]);
  const abbrev = shouldUseTwoChars ? lastName.slice(0, 2) : lastName[0];

  return `${parts[0]} ${parts[1] || ""} ${abbrev || ""}.`;
};

const groupNodeWithChildren = (
  node: Record<string, any>,
  allDivisions: Record<string, any>[],
  level = 0,
  allowedTypes?: string[]
): Record<string, any> => {
  const children = allDivisions
    .filter(
      (division) =>
        division.parent === node.id && (!allowedTypes || allowedTypes.includes(division.type_label))
    )
    .map((child) => groupNodeWithChildren(child, allDivisions, level + 1, allowedTypes));

  return {
    id: node.id,
    children,
    code: node.code,
    has_children: children.length > 0,
    level,
    name: node.name,
    parent: node.parent,
    type: node.type,
    type_label: node.type_label,
  };
};

export const groupDivisionOrganization = (
  divisions: Record<string, any>[],
  allowedTypes?: string[]
) => {
  // หา root nodes (ที่ไม่มี parent หรือ parent ไม่อยู่ใน divisions)
  const rootNodes = divisions.filter((division) => {
    // กรอง type ถ้ามีการส่ง allowedTypes มา
    if (allowedTypes && !allowedTypes.includes(division.type_label)) {
      return false;
    }

    if (!division.parent) {
      return true;
    } // ไม่มี parent

    // มี parent แต่ parent ไม่อยู่ใน divisions (ไม่ได้ผูก)
    return !divisions.some((d) => d.id === division.parent);
  });

  return rootNodes.map((root) => groupNodeWithChildren(root, divisions, 0, allowedTypes));
};

// Main function สำหรับค้นหาและสร้าง tree
export const searchDivisionsAsTree = (
  divisions: Record<string, any>[],
  searchTerm?: string,
  allowedTypes?: string[]
): Record<string, any>[] => {
  // ถ้าไม่มี search term ให้ return organization tree
  if (!searchTerm?.trim()) {
    return groupDivisionOrganization(divisions, allowedTypes);
  }

  // ค้นหาและสร้าง tree จากผลลัพธ์
  const filteredDivisions = filterDivisions(divisions, searchTerm, allowedTypes);

  return filteredDivisions.map((division) =>
    groupNodeWithChildren(division, divisions, 0, allowedTypes)
  );
};

export const flattenDivisionTree = (tree: Record<string, any>[]): Record<string, any>[] => {
  const result: Record<string, any>[] = [];

  const flatten = (nodes: Record<string, any>[]) => {
    for (const node of nodes) {
      const { children, ...nodeData } = node;

      result.push(nodeData);

      if (children?.length > 0) {
        flatten(children);
      }
    }
  };

  flatten(tree);

  return result;
};

// ดึง division ที่ไม่ได้ผูกองค์กรและไม่ได้เป็น type องค์กร
export const getUnlinkedNonOrgDivisions = (
  divisions: Record<string, any>[]
): Record<string, any>[] =>
  divisions.filter((division) => {
    // ไม่ใช่ type องค์กร
    if (division.type_label === ORGANIZE_LABEL) {
      return false;
    }

    // ไม่มี parent (ไม่ได้ผูก)
    if (!division.parent) {
      return true;
    }

    // มี parent แต่ parent ไม่อยู่ใน divisions (ไม่ได้ผูก)
    return !divisions.some((d) => d.id === division.parent);
  });
